import { render, staticRenderFns } from "./debtorTop.vue?vue&type=template&id=d0c9c76c&"
import script from "./debtorTop.vue?vue&type=script&lang=js&"
export * from "./debtorTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports